import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ProgressBar = styled.div`
  background: white;
  width: 100%;
  height: 20px;
  position: relative;
  border-radius: 4px;
  &:after {
    border-radius: inherit;
    transition: ease 0.25s;
    background: linear-gradient(to right, #f49f61, #f19e85);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${({ progress }) => `${progress}%`};
    content: '';
  }
`;

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {
  progress: 0,
};

export default ProgressBar;
